<template>
	<v-row no-gutters>
		<v-autocomplete
			:label="label"
			multiple
			chips
			deletable-chips
			v-model="selectedGridViewFields"
			:items="gridViewFields"
			@change="onSelectionChanged"
			item-text="Label"
			item-value="Id"
		/>
	</v-row>
</template>
<script>
import { gridViewConnectorHeaderType } from '../../../../../enums/gridViewConnectorHeaderType';
import {
	ConnectorsListGetters,
	ConnectorHeadersGetters,
} from '../../../../../store/getters';
import {
	ConnectorHeaderActions,
	GeneralActions,
} from '../../../../../store/actions';
import { mapGetters } from 'vuex';
export default {
	name: 'ConnectorHeaders',
	props: {
		headerType: Number,
	},
	computed: {
		...mapGetters({
			gridViewFields: [ConnectorsListGetters.GRID_VIEW_FIELDS],
			selectedConnector: [ConnectorHeadersGetters.SELECTED_CONNECTOR],
			childHeaders: [ConnectorHeadersGetters.CHILD_HEADERS],
			parentHeaders: [ConnectorHeadersGetters.PARENT_HEADERS],
		}),
		label() {
			if (this.headerType == gridViewConnectorHeaderType.Parent)
				return 'Parent Headers';
			return 'Child Headers';
		},
		dataSource() {
			if (this.headerType == gridViewConnectorHeaderType.Parent) {
				return this.parentHeaders.map((x) => x.GridViewFieldId);
			}

			if (this.headerType == gridViewConnectorHeaderType.Child) {
				return this.childHeaders.map((x) => x.GridViewFieldId);
			}

			return [];
		},
	},
	data() {
		return {
			selectedGridViewFields: [],
		};
	},
	mounted() {
		this.$store
			.dispatch(ConnectorHeaderActions.LOAD, this.selectedConnector)
			.then(() => {
				if (this.headerType == gridViewConnectorHeaderType.Parent) {
					this.selectedGridViewFields = this.parentHeaders.map(
						(x) => x.GridViewFieldId
					);
				}

				if (this.headerType == gridViewConnectorHeaderType.Child) {
					this.selectedGridViewFields = this.childHeaders.map(
						(x) => x.GridViewFieldId
					);
				}
			});
	},
	destroyed() {
		this.$store.dispatch(ConnectorHeaderActions.CLEAR);
	},
	methods: {
		onSelectionChanged(selection) {
			let promises = [];
			if (!selection) selection = [];

			selection.forEach((gvfId) => {
				if (!this.dataSource.includes(gvfId)) {
					promises.push(this.addGridViewFieldIdItem(gvfId));
				}
			});

			this.dataSource.forEach((gvfId) => {
				if (!selection.includes(gvfId)) {
					promises.push(this.removeGridViewFieldId(gvfId));
				}
			});

			this.$store.dispatch(GeneralActions.LOADING, true);
			Promise.all(promises)
				.catch((error) => {
					this.$store.dispatch(GeneralActions.ERROR, error);
				})
				.finally(() => {
					this.$store.dispatch(GeneralActions.LOADING, false);
				});
		},

		buildItemForGridViewFieldId(gvfId) {
			return {
				GridViewFieldId: gvfId,
				GridViewConnectorId: this.selectedConnector.Id,
				HeaderType: this.headerType,
			};
		},

		addGridViewFieldIdItem(gvfId) {
			return this.$store.dispatch(
				ConnectorHeaderActions.ADD,
				this.buildItemForGridViewFieldId(gvfId)
			);
		},

		removeGridViewFieldId(gvfId) {
			let item = null;
			if (this.headerType == gridViewConnectorHeaderType.Parent) {
				item = this.parentHeaders.find(
					(x) => x.GridViewFieldId == gvfId
				);
			}

			if (this.headerType == gridViewConnectorHeaderType.Child) {
				item = this.childHeaders.find(
					(x) => x.GridViewFieldId == gvfId
				);
			}
			return this.$store.dispatch(ConnectorHeaderActions.DELETE, item);
		},
	},
};
</script>
